// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"70436a61","616":"c1d4e9bd","634":"aeed368c","937":"394b863c","939":"8c343291"}[chunkId] + ".chunk.css";
};